import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import * as fromOrders from './reducers/orders.reducer';
import { EffectsModule } from '@ngrx/effects';
import { OrdersEffects } from './effects/orders.effects';



@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(fromOrders.ordersFeatureKey, fromOrders.reducer),
    EffectsModule.forFeature([OrdersEffects])
  ]
})
export class OrdersStoreModule { }
